import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { BlotterOrderEntryFromBackend } from '@/store/blotter/api/types/BlotterOrderEntryFromBackend.ts';

export type BlotterActiveOrdersListQueryPayload = {
  showMyMainDeals: boolean;
};

export const activeOrdersList = (builder: WebapiEndpointBuilder) => {
  return builder.query<BlotterOrderEntryFromBackend[], BlotterActiveOrdersListQueryPayload>({
    // we need to disable caching for this query, it populates blotter grids at start and whenever filtering changes and new trades show up any time
    keepUnusedDataFor: 0,
    query: (body) => ({
      url: '/blotter/activeOrderList', // no s
      method: 'POST',
      body,
      headers: {
        Accept: '*/*', // will respond with a string of the json-serialized payload if we give Accept: Application/json (true story)
      },
    }),
  });
};
